// Company CRM options for signup form
export const COMPANY_CRM_OPTIONS = [
    'hubspot',
    'pipedrive',
    'zoho',
    'guesty',
    'ghl',
    'salesforce', 
    'other',
    'none'
]

// Teams options for signup form
export const TEAMS_OPTIONS = [
    'sales',
    'support', 
    'marketing',
    'customer_success',
    'other',
    'Select All'
]

// Company size options for signup form
export const COMPANY_SIZE_OPTIONS = [
    '1-10',
    '11-50',
    '50-100',
    '100-500',
    '500-2500',
    '2500+'
]

// Number of licenses options for signup form
export const TEAM_SIZE_OPTIONS = [
    '1-4',
    '5-9',
    '10-24',
    '25-99',
    '100-249',
    '250+'
]

// Display name mappings for CRM options
export const COMPANY_CRM_DISPLAY_NAMES = {
    'hubspot': 'HubSpot',
    'pipedrive': 'Pipedrive',
    'zoho': 'Zoho',
    'guesty': 'Guesty',
    'ghl': 'HighLevel',
    'salesforce': 'Salesforce',
    'other': 'Other',
    'none': 'None'
}

// Display name mappings for Teams options
export const TEAMS_DISPLAY_NAMES = {
    'sales': 'Sales',
    'support': 'Support',
    'marketing': 'Marketing',
    'customer_success': 'Customer Success',
    'other': 'Other',
    'select_all': 'Select All'
}
